import { openDB } from 'idb'

import { log } from 'src/services/app/log.service'
import { STORAGE_KEYS } from 'src/services/consts/api.const'
import { IDB_CONFIG } from 'src/services/consts/app.const'

const { DB_NAME, DB_VERSION, DEFAULT_CACHE_TIME } = IDB_CONFIG

let db = null

async function ensureDB() {
  if (!db) {
    try {
      db = await openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
          // Create stores if they don't exist
          if (!db.objectStoreNames.contains(STORAGE_KEYS.COMPANIES)) {
            db.createObjectStore(STORAGE_KEYS.COMPANIES)
          }
        },
      })
      //   log.info('IndexedDB initialized successfully')
    } catch (err) {
      log.error('Failed to initialize IndexedDB:', err)
      throw err
    }
  }
  return db
}

function isCacheValid(cacheTimestamp) {
  return Date.now() <= cacheTimestamp
}

async function getData(key, storeName = STORAGE_KEYS.COMPANIES) {
  try {
    const db = await ensureDB()
    const cachedItem = await db.get(storeName, key)

    if (!cachedItem) return null

    // Check if cache is still valid
    if (cachedItem.expirationTime && !isCacheValid(cachedItem.expirationTime)) {
      //   log.info(`Cache expired for ${key} in ${storeName}`)
      await removeData(key, storeName)
      return null
    }

    return cachedItem.data
  } catch (err) {
    log.error(`Failed to get data from ${storeName}:`, err)
    return null
  }
}

async function setData(
  key,
  data,
  storeName = STORAGE_KEYS.COMPANIES,
  expirationTime = DEFAULT_CACHE_TIME,
) {
  try {
    const db = await ensureDB()
    const cachedData = {
      data,
      expirationTime: Date.now() + expirationTime,
    }

    await db.put(storeName, cachedData, key)
    // log.info(
    //   `Data stored in ${storeName} successfully, expires in ${expirationTime / 1000 / 60} minutes`,
    // )
    return true
  } catch (err) {
    log.error(`Failed to store data in ${storeName}:`, err)
    return false
  }
}

async function removeData(key, storeName = STORAGE_KEYS.COMPANIES) {
  try {
    const db = await ensureDB()
    await db.delete(storeName, key)
    // log.info(`Data removed from ${storeName} successfully`)
    return true
  } catch (err) {
    log.error(`Failed to remove data from ${storeName}:`, err)
    return false
  }
}

async function clearStore(storeName = STORAGE_KEYS.COMPANIES) {
  try {
    const db = await ensureDB()
    await db.clear(storeName)
    // log.info(`Store ${storeName} cleared successfully`)
    return true
  } catch (err) {
    log.error(`Failed to clear store ${storeName}:`, err)
    return false
  }
}

export const idbService = {
  getData,
  setData,
  removeData,
  clearStore,
}
